import { SVGProps, Ref, forwardRef } from 'react';

export const ConstructionHatFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.253 1c1.147 0 1.72 0 2.101.344.234.211.344.507.422.966.05.291.087.648.131 1.091l.493 4.932h1.407L12.3 3.26q-.02-.177-.04-.354c2.288 1.322 2.95 4.095 3.056 8.356.423.402.684.967.684 1.586 0 .894-.56 1.658-1.445 1.788-1.186.175-3.226.36-6.555.36s-5.369-.185-6.555-.36C.561 14.507 0 13.744 0 12.85c0-.619.26-1.185.684-1.587.105-4.26.768-7.033 3.054-8.355l-.038.354-.507 5.072H4.6L5.093 3.4c.044-.44.08-.794.129-1.084.078-.463.19-.76.424-.973.285-.258.68-.322 1.342-.338L7.748 1zm-3.92 10.93h7.334v-1.4H4.333z"
                fill="currentColor"
            />
        </svg>
    )
);
ConstructionHatFilledSize16Glyph.displayName = 'ConstructionHatFilledSize16Glyph';
